import {Component, Input, ViewEncapsulation} from '@angular/core';
import { OfferCardType } from "../../offer-card-data.model";
import { AbstractOfferCard } from '../abstract-offer-card.component';

@Component({
  selector: 'reduced-offer-card',
  template: `
    <offer-card [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId" [positionIndex]="positionIndex"
                [data]="data" [currency]="currency" [locale]="locale" [loyaltyMode]=" loyaltyMode"
                [flow]="flow" [product]="product" [offerCardType]="offerCardType" [moduleReferer]="moduleReferer">

      <offer-image offer-image 
        [highlighted]="highlighted" [product]="product"
        [mediaKey]="data.picture_link"
        [alt]="data.product_text + ' - ' + data.main_text"></offer-image>
      
      <ng-container offer-content>
        <offer-card-detail-info [moduleId]="moduleId" [moduleIndex]="moduleIndex"
                                [positionIndex]="positionIndex" [offerCardType]="offerCardType"
                                [data]="data" [loyaltyMode]="loyaltyMode" [locale]="locale"
                                [flow]="flow"></offer-card-detail-info>

        <div class="offer-card-description-container" *ngIf="data.description">
          <p class="offer-card-description-content offer-card-description" [innerHTML]="data.description"></p>
        </div>

        <offer-drivers [drivers]="data.drivers" [stars]="data.stars"></offer-drivers>

      </ng-container>
    </offer-card>
  `,
  styleUrls: ['./reduced-offer-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReducedOfferCardComponent extends AbstractOfferCard {
  readonly offerCardType = OfferCardType.REDUCED;

  @Input() highlighted = false;
}
